import { render } from "./Auth.vue?vue&type=template&id=6195d106"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/pages/Auth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6195d106"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6195d106', __exports__)) {
    api.reload('6195d106', __exports__)
  }
  
  module.hot.accept("./Auth.vue?vue&type=template&id=6195d106", () => {
    api.rerender('6195d106', render)
  })

}


export default __exports__